import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const carApi = createApi({
  reducerPath: "carApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/v1/travel/cars`,
  }),
  tagTypes: ["Cars"],
  endpoints: (builder) => ({
    getCars: builder.query<any[], void>({
      query: () => "/",
      providesTags: ["Cars"],
    }),
    createCar: builder.mutation<any, any>({
      query: (car) => ({ url: "/", method: "POST", body: car }),
      invalidatesTags: ["Cars"],
    }),
    updateCar: builder.mutation<any, { id: string; car: any }>({
      query: ({ id, car }) => ({ url: `/${id}`, method: "PUT", body: car }),
      invalidatesTags: ["Cars"],
    }),
    deleteCar: builder.mutation<any, string>({
      query: (id) => ({ url: `/${id}`, method: "DELETE" }),
      invalidatesTags: ["Cars"],
    }),
  }),
});

export const {
  useGetCarsQuery,
  useCreateCarMutation,
  useUpdateCarMutation,
  useDeleteCarMutation,
} = carApi;
